module.exports = __webpack_public_path__ + "assets/f2da9c253dce487c338ab904515a977e.jpg";